var _rect, _rect2, _rect3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInFeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 76,
    viewBox: "0 0 140 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 84,
    height: 20,
    fill: "#EFEEEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 56,
    width: 84,
    height: 20,
    fill: "#EFEEEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 84,
    height: 20,
    fill: "#DAD8DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1844 37.7112L67.2344 32.5799C67.0125 32.3893 66.6875 32.5612 66.6875 32.869V43.1315C66.6875 43.4393 67.0125 43.6112 67.2344 43.4205L73.1844 38.2893C73.3547 38.1424 73.3547 37.858 73.1844 37.7112Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140 24L2.80142e-06 24",
    stroke: "#6E28FC",
    strokeDasharray: "3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140 52L2.80142e-06 52",
    stroke: "#6E28FC",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInFeedIcon);
export default __webpack_public_path__ + "static/media/in-feed-icon.7f557193b80556d02060f65a2f29ae1c.svg";
export { ForwardRef as ReactComponent };